import styled from 'styled-components';

export const StyledLineChartCard = styled.div`
  > h3 {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    position: absolute;
    top: 16px;
    left: 17px;
  }
`;

export const StyledGraphWrapper = styled.div`
  position: relative;
  margin-top: 30px;

  > canvas {
    position: relative;
    height: 170px !important;
  }
`;
